import Toast from "../components/infos/Toast.vue";

// Conteneur qui englobe tous les toasts
const toastContainer = document.createElement("aside");
toastContainer.setAttribute("id", "toast_container");
document.body.appendChild(toastContainer);

const toasts = [];

const toastApi = (app) => ({
  init(Vue) {
    Vue.$toast = this;
    Vue.prototype.$toast = this;
  },

  createToast(variant, options) {
    const ToastConstructor = app.extend(Toast);

    const toastInstance = new ToastConstructor({
      propsData: {
        variant,
        title: options.title,
        content: options.content,
        isEntering: true, // Active l'animation d'entrée
        isExiting: false,
        customClass: "custom-fade", // On veut les animations uniquement pour les toasts en haut à droite de l'écran
        delay: options.delay, // Durée avant la fermeture automatique du toast
      },
    });

    toastInstance.$mount();

    // Ajout du toast au conteneur
    toastContainer.appendChild(toastInstance.$el);
    toasts.push(toastInstance);

    // Désactive l'animation d'entrée après un court délai (sans timeout, l'animation d'entrée ne se fait pas)
    setTimeout(() => {
      toastInstance.isEntering = false;
    }, 100);

    // Gestion de la fermeture du toast
    const closeToast = () => {
      if (toastContainer.contains(toastInstance.$el)) {
        toastInstance.isExiting = true; // Active l'animation de sortie

        setTimeout(() => {
          toastContainer.removeChild(toastInstance.$el);
          toastInstance.$destroy();

          const index = toasts.indexOf(toastInstance);
          if (index !== -1) {
            toasts.splice(index, 1);
          }
        }, 400); // À peine plus que la durée de transition
      }
    };

    toastInstance.$on("close", closeToast);

    // Cache puis supprime le toast après un délai s'il n'a pas déjà été supprimé
    if (toastContainer.contains(toastInstance.$el)) {
      setTimeout(() => {
        closeToast();
      }, toastInstance.delay);
    }
  },

  info(options) {
    this.createToast("info", options);
  },

  success(options) {
    this.createToast("success", options);
  },

  error(options) {
    this.createToast("error", options);
  },

  warning(options) {
    this.createToast("warning", options);
  },
});

export default (Vue) => {
  const methods = toastApi(Vue);
  Vue.$toast = methods;
  Vue.prototype.$toast = methods;
  methods.init(Vue);
};
